import { getChartColor } from '@/explore/components/charts/utils';
import { ChartType, SeriesItemViewOptions } from '@/explore/types';

export const getSeriesItemColor = (seriesOptions: SeriesItemViewOptions, idx: number): string =>
  seriesOptions.color ?? getChartColor(idx);

export const getSeriesItemChartType = (
  seriesOptions: SeriesItemViewOptions,
  defaultChartType: ChartType,
): ChartType => seriesOptions.chartType ?? defaultChartType;

export const getSeriesItemShowValues = (seriesOptions: SeriesItemViewOptions): boolean =>
  seriesOptions.showValues ?? false;
